import axios from './index';

export default {
  contractUs(data) {
    return axios.post('/api/contact', data);
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js